import React from 'react';

import ProgressBar from '../ProgressBar';
import SocialButtonLogin from '../../components/login/SocialButtonLogin';
import googleLogo from '../../images/google.png';
import RetinaImage from 'react-retina-image';

const Card = ({ children, mailSignIn, resetPassword, ...props }) => {
  
  const handleKeyPress = (event) => {
    event.key === "Enter" && mailSignIn(email.value, password.value);
  }

  const handleEsqueceuSenha = () => {
    let emailUsuario = window.prompt("Digite o seu endereço de e-mail:");
    emailUsuario !== null && emailUsuario !== "" &&
    resetPassword(emailUsuario)
  }

  let email, password;
  return (
    <div className="card-login mdl-card mdl-shadow--2dp">
      <div className="m-4">
        {/* <RetinaImage className="header-logo" src={copLogo} /> */}
        <div className="mt-4">

          <div className="form-group">
            <input type="email" className="form-control" onKeyPress={handleKeyPress} placeholder="E-mail" ref={ node => email = node } />
          </div>

          <div className="form-group">
            <input type="password" className="form-control" onKeyPress={handleKeyPress} placeholder="Senha" ref={ node => password = node } />
          </div>

          <button className="sign-in-btn mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent"
              onClick={ () => mailSignIn(email.value, password.value) }>
            { props.userIsLoading ? 'aguarde...' : 'Entrar' }
          </button>
          <ProgressBar style={{ display: props.userIsLoading ? 'block' : 'none' }} />
          <div className="container-esqueceu-senha mt-4">
            <a href="#" onClick={handleEsqueceuSenha}>Esqueceu sua senha?</a>
          </div>

          {/* <div className="mdl-card__supporting-text">
            Ainda não tem conta? <Link to="/signup">Cadastrar</Link>
          </div> */}
        </div>
      </div>

      <div className="mdl-card__actions sign-in-actions">
        <div className="mdl-card__supporting-text">
          <p>
            Entrar com: 
            <a className={"btn btn-social-icon"} onClick={ () => props.googleSignIn() }>
              <RetinaImage src={googleLogo}  />
            </a>
            {/* <SocialButtonLogin type="google" onClick={ () => props.googleSignIn() } /> */}
          </p>
          {/* <div className="row justify-content-md-center">
            <div className="col col-md-2">
              <SocialButtonLogin type="google" onClick={ () => props.googleSignIn() } />
            </div>
            <div className="col col-md-2">
              <SocialButtonLogin type="facebook" onClick={ () => props.facebookSignIn() } />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/login/CardSignIn.js